import { NfcCardSearch, NfcCardsPage, fetchNfcCards } from 'lib/models/nfcCards';
import { useCallback, useEffect, useState } from 'react';

const emptyPage: NfcCardsPage = { elements: [], total: 0, failed: false };

function useNfcCards(search: NfcCardSearch) {
	const [loading, setLoading] = useState<boolean>(false);

	const [page, setPage] = useState<NfcCardsPage>(emptyPage);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchNfcCards(search);
		setPage(response);
		setLoading(false);
	}, [search]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, cards: page.elements, total: page.total, failed: page.failed, refetch };
}

export default useNfcCards;
